/**
 * @generated SignedSource<<61c6bbe5e95aeff889c00b613576f8df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_PullRequests$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_PullRequestsList">;
  readonly " $fragmentType": "main_softwareCodePage_PullRequests";
};
export type main_softwareCodePage_PullRequests$key = {
  readonly " $data"?: main_softwareCodePage_PullRequests$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_PullRequests">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "updatedFrom"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_PullRequests",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "updatedFrom",
          "variableName": "updatedFrom"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_PullRequestsList"
    }
  ],
  "type": "Query"
};

(node as any).hash = "39c3c02eb6404593e12befe03af4706e";

export default node;
